import React from "react";
import { DocEntityMap, DocEntityProps } from "../../Language";
import { BjornLundenSV as SV } from "./BjornLundenSV";
import "../../Documents.css";

const docsMap: DocEntityMap = { SV };

export const BjornLunden: React.FC<DocEntityProps> = (props) =>
  React.createElement(docsMap[props.language], props);
